import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types';

interface ContentCardProps {
  item: ContentItem;
}

export default function ContentCard({ item }: ContentCardProps) {
  return (
    <Link
      to={`/article/${item.slug}`}
      className="group block"
    >
      <article className="relative overflow-hidden rounded-lg bg-background-800/50 hover:bg-background-700/50 transition-all duration-300">
        <div className="relative aspect-[2/3] overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} - 777影院在线观看`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent" />
          <div className="absolute top-2 left-2">
            <span className="inline-block px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500/90 text-background-50">
              {item.rating}
            </span>
          </div>
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 rounded-md text-xs bg-background-950/70 text-foreground-300">
              {item.category}
            </span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <p className="text-xs text-accent-500 mb-1">{item.updateInfo}</p>
            <h3 className="text-sm font-semibold text-foreground-100 line-clamp-1 group-hover:text-primary-400 transition-colors">
              {item.title}
            </h3>
          </div>
        </div>
        <div className="p-3">
          <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.description}</p>
          <div className="flex flex-wrap gap-1.5 mt-2">
            {item.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 rounded text-[10px] bg-background-700 text-foreground-500"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </article>
    </Link>
  );
}